import { KoyouKeiyakuApi } from "@/api/KoyouKeiyakuApi";
import { SearchKoyouKeiyakuReq, KoyouKeiyakuAgreementReq } from "@/types/KoyouKeiyaku";
import { KoyouKeiyakuDetail } from "@/types/KoyouKeiyakuDetail";

export class KoyouKeiyakuService {

  /**
   * 検索条件に一致した雇用契約書の情報を取得します
   * @param req 
   * @returns 
   */
  public async searchKeiyaku(req: SearchKoyouKeiyakuReq) {
    const api = new KoyouKeiyakuApi();
    try {
      return await api.searchKeiyaku(req);
    } catch (e) {
      throw e;
    }
  }

  /**
   * 雇用契約書の詳細を取得します
   * @param id 
   * @returns 
   */
  public async getDetail(id: number) {
    const api = new KoyouKeiyakuApi();
    try {
      let res = await api.getDetail(id);
      return res
    } catch (e) {
      throw e;
    }
  }

  /**
  * 雇用契約書をダウンロードします
  * @returns
  */
  public async downLoad(id: number): Promise<any> {
    const api = new KoyouKeiyakuApi();
    try {
      return await api.downLoad(id);
    } catch (e: any) {
      console.log("ダウンロードに失敗しました。");
      return null;
    }
  }

  /**
   * 雇用契約書（伺い書）を作成し、登録内容を返します
   * @param form
   * @returns 
   */
  public async upsert(form: KoyouKeiyakuDetail) {
    const api = new KoyouKeiyakuApi();
    try {
      let res = await api.upsert(form);
      return res
    } catch (e) {
      throw e;
    }
  }

  public async getAllOptions() {
    const api = new KoyouKeiyakuApi();
    try {
      let res = await api.getAllOptions()
      return res
    } catch (e) {
      throw e;
    }
  }

  /**
 * 雇用契約書を提出します
 * @param number
 * @returns
 */
  public async submit(id: number) {
    const api = new KoyouKeiyakuApi();
    try {
      return await api.submit(id);
    } catch (e) {
      throw e;
    }
  }

  /**
 * 承認処理を行います
 * @param params
 * @returns
 */
  public async approval(id: number, result: number, notes: string | null) {
    const api = new KoyouKeiyakuApi();
    try {
      return await api.approval(id, result, notes ? notes : null);
    } catch (e) {
      throw e;
    }
  }

  /**
  * 確認処理を行います
  * @param params
  * @returns
  */
  public async check(id: number, notes: string | null) {
    const api = new KoyouKeiyakuApi();
    try {
      return await api.check(id, notes ? notes : null);
    } catch (e) {
      throw e;
    }
  }

  /**
 * お知らせを既読にします
 * @param params
 * @returns
 */
  public async readDeniedMessage(id: number) {
    const api = new KoyouKeiyakuApi();
    try {
      return await api.readDeniedMessage(id);
    } catch (e) {
      throw e;
    }
  }

  /**
 * 雇用契約書を削除します
 * @param number
 * @returns
 */
  public async deleteKoyouKeiyaku(id: number) {
    const api = new KoyouKeiyakuApi();
    try {
      return await api.deleteKoyouKeiyaku(id);
    } catch (e) {
      throw e;
    }
  }

  /**
 * 雇用契約書を削除します
 */
  public async modifyKoyouKeiyaku(koyouKeiyakuDetail: KoyouKeiyakuDetail): Promise<boolean> {
    const api = new KoyouKeiyakuApi();
    try {
      return await api.modifyKoyouKeiyaku(koyouKeiyakuDetail);
    } catch (e) {
      throw e;
    }
  }

  /**
   * 指定された雇用契約書IDから、雇用契約情報取得APIを実行し結果を返します
   * @param number
   * @returns
  */
  public async findAllApprovedByUserId(userId: number) {
    const api = new KoyouKeiyakuApi();
    try {
      return await api.findAllApprovedByUserId(userId);
    } catch (e) {
      throw e;
    }
  }

  /**
   * 指定ユーザーの雇用契約のうち、内容変更が可能な雇用契約の取得
   * @param number
   * @returns
  */
  public async findAllChangeableKoyouKeiyaku(userId: number) {
    const api = new KoyouKeiyakuApi();
    try {
      return await api.findAllChangeableKoyouKeiyaku(userId);
    } catch (e) {
      throw e;
    }
  }

  /**
   * 雇用契約書の本人承認ステータスを更新します
  */
  public async agreement(id: number, status: number, notes: string | null) {
    const api = new KoyouKeiyakuApi();
    const req: KoyouKeiyakuAgreementReq = {
      koyouKeiyakuId: id,
      status,
      notes
    }
    try {
      return await api.agreement(req);
    } catch (e) {
      throw e;
    }
  }

  /**
   * 履歴書のURLを返却します
  */
  public async getRirekisyoUrl(id: number) {
    const api = new KoyouKeiyakuApi();
    try {
      return await api.getRirekisyoUrl(id);
    } catch (e) {
      throw e;
    }
  }

  /**
   * 雇用契約の担当営業に設定できるユーザーを返します
   */
  public async getKoyouKeiyakuEigyouUser() {
    const api = new KoyouKeiyakuApi();
    try {
      return await api.getKoyouKeiyakuEigyouUser()
    } catch (e) {
      throw e;
    }
  }

  /**
   * 雇用契約の担当営業に設定できるユーザーを返します（オプション値）
   */
  public async getKoyouKeiyakuEigyouUserOptions() {
    const api = new KoyouKeiyakuApi();
    try {
      return await api.getKoyouKeiyakuEigyouUserOptions()
    } catch (e) {
      throw e;
    }
  }
}
